import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-defer-panel',
  imports: [CommonModule],
  template: ` <div class="tw-border tw-w-full" [style.height]="height"></div> `,
})
export class DeferPanelComponent {
  @Input({ required: true })
  height: string;
}
